import z from "zod";

/**
 * Transport stage values as exposed by foodpilot-api ({@code App\Enum\TransportStage}).
 * Order matches the Ecobalyse lifecycle plus FoodPilot's retail-to-consumer
 * extension and the catch-all `custom` slot.
 */
export const TRANSPORT_STAGES = [
    "ingredient_to_processing_site",
    "packaging_to_processing_site",
    "product_to_storage",
    "storage_to_retail",
    "retail_to_consumer",
    "custom",
] as const;

export type TransportStage = (typeof TRANSPORT_STAGES)[number];

/** Stages that anchor on a {@code ProductIngredient} (recipe line). */
export const INGREDIENT_LEVEL_STAGES = [
    "ingredient_to_processing_site",
] as const satisfies ReadonlyArray<TransportStage>;

/** Stages applied at the whole-product grain. */
export const PRODUCT_LEVEL_STAGES = [
    "product_to_storage",
    "storage_to_retail",
    "retail_to_consumer",
] as const satisfies ReadonlyArray<TransportStage>;

export const PACKAGING_LEVEL_STAGES = ["packaging_to_processing_site"] as const satisfies ReadonlyArray<TransportStage>;

export const TransportStageSchema = z.enum(TRANSPORT_STAGES);
